import Link from 'next/link'

import type { Category } from '@twisto/api-cms'
import { Typography } from '@twisto/components/atoms/typography'

import * as styles from './category-box.styles'
import { CategoryIcon } from './category-icon'

type Props = {
  name?: string
  description?: string
  icon?: Category['icon']
  path?: string
}

export const CategoryBox = ({ name, description, icon, path }: Props) => (
  <Link css={styles.root} href={path ?? ''} legacyBehavior={false}>
    <CategoryIcon css={styles.icon} icon={icon} />
    <Typography
      color="textPrimary"
      component="h3"
      css={styles.headline}
      fontWeight="medium"
      variant="b1"
    >
      {name}
    </Typography>
    <Typography color="textSecondary" variant="b2">
      {description}
    </Typography>
  </Link>
)
